import React, { useMemo } from "react";
// import { useAppData } from "@danishagro/shared/src/contexts/appData.context";
// import { DA_MiniCartPopUpB2cMobile } from "@danishagro/b2c/src/components/organisms/SiteHeader/MiniCart/MiniCartMobile/MiniCartMobile.component";
import { useCart } from "@danishagro/shared/src/contexts/cart/cart.context";
import { useSiteHeader } from "@danishagro/shared/src/contexts/siteHeader.context";
import { DA_MiniCartPopUp } from "@organisms/SiteHeaderB2B/MiniCart/MiniCart.component";
import { useBottomSheet } from "@danishagro/shared/src/contexts/bottomSheet/bottomSheet.context";
import { useTranslations } from "@danishagro/shared/src/contexts/translations/translations.context";

export const useCartButton = () => {
    const { orderLines, isLoadingCart } = useCart();
    const { showMiniCart, closeMobileNav, showMobileNav } = useSiteHeader();
    const { getDictionaryString } = useTranslations();
    // const { currentSite } = useAppData();

    const { presentBottomSheet, dismissBottomSheet, activeBottomSheet } = useBottomSheet();

    const onCartButtonClicked = () => {
        const id = "cart";

        if (activeBottomSheet !== id) {
            // TODO: Disabled B2C for now due to reference issue. Clean up in B2C folder.
            // presentBottomSheet(
            //     currentSite === "B2C" ? <DA_MiniCartPopUpB2cMobile /> : <DA_MiniCartPopUp />,
            //     currentSite === "B2C"
            //         ? {
            //               id: id,
            //               headerTitle: getDictionaryString("header.miniBasket.title", {
            //                   uppercaseFirst: true,
            //               }),
            //           }
            //         : {
            //               id: id,
            //               headerTitle: getDictionaryString("miniCartTitle", {
            //                   uppercaseFirst: true,
            //               }),
            //           }
            // );
            presentBottomSheet(<DA_MiniCartPopUp />, {
                id: id,
                headerTitle: getDictionaryString("miniCartTitle", {
                    uppercaseFirst: true,
                }),
            });
            // Close mobileNav after bottomSheet has opened
            if (showMobileNav) {
                setTimeout(() => {
                    closeMobileNav();
                }, 500);
            }
        } else {
            dismissBottomSheet();
        }
    };

    // Mappers

    const totalQuantity = useMemo(() => {
        if (orderLines?.[0]) {
            return orderLines.reduce((total, line) => total + line.quantity, 0);
        }

        return 0;
    }, [orderLines]);

    return {
        showCart: true,
        onCartButtonClicked,
        cartBadge: totalQuantity,
        isCartMenuActive: showMiniCart,
        isLoadingCart,
    };
};
